import React from 'react';
import { useLocation } from 'react-router-dom';
import { SelectedFilters } from 'components';
import { PAYROLL_FLAGGED_ENUMS, renderDateRange, renderStaffName } from 'utils';
import { payrollTypeFilterList, timeSheetTabEnums } from '../constants';

export const TIMESHEET_POPOVER_KEYS = ['staffs', 'staffFull', 'flag', 'start', 'end'];

export const TimeSheetSelectedFilters = () => {
    const location = useLocation();
    const info = location?.state;
    const isProcessed = info?.tabType === timeSheetTabEnums?.PROCESSED;

    const filtersList = [
        {
            name: isProcessed ? 'Processor' : 'Staff',
            key: 'staffs',
            pairKey: 'staffFull',
            render: (s, state) => {
                const id = s?.id ?? s;
                const full = state?.staffFull?.find((i) => i?.id === id);
                return full ? renderStaffName(full) : id;
            },
        },
        { name: 'Flag', key: 'flag', options: PAYROLL_FLAGGED_ENUMS.map((i) => ({ id: i.id, name: i.label })), show: isProcessed },
        { name: 'DOS', keys: ['start', 'end'], render: ([start, end]) => renderDateRange(start, end) },
        { name: 'Type', key: 'type', options: payrollTypeFilterList, show: !isProcessed },
        { name: 'Search', key: 'searchValue', companions: ['searchKey'] },
    ];

    return <SelectedFilters filtersList={filtersList} resetParams={{ skip: 0, limit: 50, page: 1 }} doNotCrop />;
};
